import { useContext } from "react";
import { PassCodeContext } from "../PassCodeContext/PassCodeContext";
import PassCodePage from "../PassCodePage/PassCodePage";

function ProtectedRoute({ children }) {
  const { authorized } = useContext(PassCodeContext);

  if (!authorized) {
    return <PassCodePage />;
  }

  return children;
}

export default ProtectedRoute;